import './index.less';

const UnDevelop = function () {
  return <div className="un-develop">暂未开发，敬请期待！</div>;
};

export default UnDevelop;
